import axios, { AxiosResponse } from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { DynamicSection } from '@fiverr-private/ai_brief';
import { Gql } from '@fiverr-private/dynamic_matching';
import { Range } from '../types/range';
import type { DynamicMatchingCreationResponse } from '.';

export type SubmitBriefResponse = string;

export const submitBriefUrl = pathfinder('create_dm_brief');

export type MetadataAnswersType = Partial<{
    service_options: Record<string, string[]>;
    freelancer_preferences: {
        languages?: {
            language_code: string;
            min_proficiency: Gql.LanguageProficiencyLevel;
        }[];
        countries?: Gql.DmBriefCountryCode[];
        regions?: string[];
        timezone?: {
            timezone_id: string;
            max_offset_hours: number;
        };
        freelancer_type?: {
            min_level?: Gql.DmBriefSellerLevel;
            is_vetted_pro?: boolean;
            agency_preference?: string;
        };
    };
}>;

export interface ExperimentAllocation {
    experiment_id: number;
    allocation_date: string;
    allocation_group: number;
}

export interface Money {
    amount: number;
    currency: string;
}

export type ScreeningQuestion = Pick<Gql.DmBriefScreeningQuestion, 'kind' | 'question'>;

export interface SubmitBriefRequestData extends DynamicMatchingCreationResponse {
    category_id?: number;
    preferred_tier?: Gql.DmBriefTier;
    sub_category_id: number;
    nested_sub_category_id: number | null;
    title: string;
    content: {
        generated_content: Pick<DynamicSection, 'id' | 'title' | 'content'>[];
    };
    description: string;
    metadata_answers: MetadataAnswersType;
    relaxed_metadata_answers?: MetadataAnswersType;
    budget_in_cents?: number;
    budget_range_in_cents?: Range<number>;
    pricing_type?: Gql.BriefPricingType | null;
    delivery_date_epoch_ms?: number;
    search_query?: string;
    summary?: string;
    timeline?: string;
    attachment_ids?: string[];
    original_buyer_budget?: Money;
    original_buyer_budget_range?: Range<Money>;
    need_type?: Gql.DmBriefNeedType;
    need_type_details?: {
        ongoing_work_potential?: boolean;
    };
    buyer_type?: Gql.BuyerType;
    experiment_allocations?: Record<number, ExperimentAllocation>;

    screening_questions?: ScreeningQuestion[];
}

export const submitBrief = async (submitBriefRequest: SubmitBriefRequestData) =>
    axios.post<SubmitBriefResponse, AxiosResponse<SubmitBriefResponse>, SubmitBriefRequestData>(
        submitBriefUrl,
        submitBriefRequest
    );
